const PERFILES_CERTIFICACION_POLICIAL = {
  DP_ADMINISTRADOR: 'DP_ADMINISTRADOR',
  DP_CUP: 'DP_CUP',
  DP_CONVOCATORIAS_CONDECORACIONES: 'DP_CONVOCATORIAS_CONDECORACIONES',
  DP_EVALUACIONES: 'DP_EVALUACIONES',
}

export const PERFILES = {
  ['Administrador IPH+']: 'ADMINSITRADOR GENERAL',
  Armeria: 'Armeria',
  ARMERIA_LOC: 'ARMERIA_LOC',
  ['ARMERIA_PASE DE LISTA']: 'ARMERIA_PASE_LISTA',
  ['ARMERIA_PERSONAL LOC']: 'ARMERIA_PERSONAL_LOC',
  ['ARMERIA_CATALOGOS E INVENTARIO ARMAS']: 'ARMERIA_CATALOGO_INVENTARIO_ARMAS',
  ['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS']: 'ARMERIA_CATALOGO_INVENTARIO_ACCESORIOS',

  Equipamiento: 'Equipamiento',
  EQUIPAMIENTO_ADMINISTRADOR: 'EQUIPAMIENTO_ADMINISTRADOR',

  Profesionalización: 'Profesionalización',
  IFCSP_RECLUTAMIENTO: 'IFCSP_RECLUTAMIENTO',
  IFCSP_ADMINISTRADOR: 'IFCSP_ADMINISTRADOR',
  IFCSP_PROFESIONALIZACION: 'IFCSP_PROFESIONALIZACION',

  ...PERFILES_CERTIFICACION_POLICIAL,

  ['Enlace C3']: 'Enlace C3',
  ['ENLACE C3_ADMINISTRADOR']: 'ENLACE_C3_ADMINISTRADOR',
  ['ENLACE C3_CAPTURA DE RESULTADOS']: 'ENLACE_C3_CAPTURA_RESULTADOS',
  ['ENLACE C3_CAPTURA DE EXPEDIENTE']: 'ENLACE_C3_CAPTURA_EXPEDIENTE',
  ['ENLACE C3_CAPTURA DE RESULTADOS']: 'ENLACE_C3_CAPTURA_RESULTADOS',

  ['Recursos Humanos']: 'Recursos Humanos',
  RH_ADMINISTRADOR: 'RH_ADMINISTRADOR',
  ['RH_TRAMITES ADMINISTRATIVOS']: 'RH_TRAMITES_ADMINISTRATIVOS',
  ['RH_CAMBIO DE ESTATUS/ADSCRIPCION']: 'RH_CAMBIO_ESTATUS/ADSCRIPCION',
  ['RH_REGISTRO DE PERSONAL']: 'RH_REGISTRO_PERSONAL',

  REP_ADMINISTRADOR: 'REP_ADMINISTRADOR',
  REP_REGISTRO: 'REP_REGISTRO',
  REP_CREDENCIALIZACION: 'REP_CREDENCIALIZACION',
  ['Personal / Site']: 'Personal/Site',
  REP_BIOMETRIA: 'REP_BIOMETRIA',

  ['Asuntos Internos']: 'Asuntos Internos',
  ['Consejo de Honor y Justicia']: 'Consejo de Honor y Justicia',
  Policia: 'Policia',
  Candidato: 'Candidato',

  ['COMISARIA_CAPTUREA']: 'COMISARIA_CAPTUREA',
  ['COMISARIA_SUPERVISOR']: 'COMISARIA_SUPERVISOR',
  ['ADMINSITRADOR GENERAL']: 'ADMINSITRADOR_GENERAL',
  ['USUARIO_ANALITICA']: 'USUARIO_ANALITICA',
  ['ANALISTA_ANALITICA']: 'ANALISTA_ANALITICA',
}

export const MODULOS = {
  ARMERIA: 'ARMERIA',
  EQUIPAMIENTO: 'EQUIPAMIENTO',
  PROFESIONALIZACION: 'PROFESIONALIZACION',
  DESARROLLO_POLICIAL: 'DESARROLLO_POLICIAL',
  ENLACE_C3: 'ENLACE_C3',
  RECURSOS_HUMANOS: 'RECURSOS_HUMANOS',
  REGISTRO_PERSONAL: 'REGISTRO_PERSONAL',
  CONSULTA_PERSONAL: 'CONSULTA_PERSONAL',
  ENLACE: 'ENLACE',
}

export const MODULOS_PERFILES = {
  [MODULOS.ARMERIA]: [
    PERFILES['Administrador IPH+'],
    PERFILES.Armeria,
    PERFILES.ARMERIA_LOC,
    PERFILES['ARMERIA_PASE DE LISTA'],
    PERFILES['ARMERIA_PERSONAL LOC'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
  ],
  [MODULOS.EQUIPAMIENTO]: [PERFILES['Administrador IPH+'], PERFILES.Equipamiento, PERFILES.EQUIPAMIENTO_ADMINISTRADOR],
  [MODULOS.PROFESIONALIZACION]: [
    PERFILES['Administrador IPH+'],
    PERFILES.Profesionalización,
    PERFILES.IFCSP_RECLUTAMIENTO,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.IFCSP_PROFESIONALIZACION,
  ],
  [MODULOS.DESARROLLO_POLICIAL]: [
    PERFILES['Administrador IPH+'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_EVALUACIONES,
    PERFILES.DP_CONVOCATORIAS_CONDECORACIONES,
    PERFILES.DP_CUP,
  ],
  [MODULOS.ENLACE_C3]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE C3_ADMINISTRADOR'],
    PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'],
    PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE'],
    PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'],
  ],
  [MODULOS.RECURSOS_HUMANOS]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_TRAMITES ADMINISTRATIVOS'],
    PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
    PERFILES['RH_REGISTRO DE PERSONAL'],
  ],
  [MODULOS.REGISTRO_PERSONAL]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES.REP_CREDENCIALIZACION,
    PERFILES['Personal / Site'],
    PERFILES.REP_BIOMETRIA,
  ],
  [MODULOS.CONSULTA_PERSONAL]: [PERFILES['Administrador IPH+']],
  [MODULOS.ENLACE]: PERFILES['Administrador IPH+'],
}
export const FEATURES = {
  CANDIDATOS: 'CANDIDATOS',
  CONTROL_ASPIRANTES: 'CONTROL_ASPIRANTES',
  CAPACITADORES: 'CAPACITADORES',
  AULAS: 'AULAS',
  CURSOS: 'CURSOS',
  CURSOS_PROGRAMADOS: 'CURSOS_PROGRAMADOS',
  SUGERENCIA_CURSOS: 'SUGERENCIA_CURSOS',
  FATIGA_ENTRADA_SALIDA_ARMA: 'FATIGA_ENTRADA_SALIDA_ARMA',
  REGISTRO_LOC: 'REGISTRO_LOC',
  INVENTARIO_ITEMS: 'INVENTARIO_ITEMS',
  ASIGNACION_ITEMS_PERSONAL: 'ASIGNACION_ITEMS_PERSONAL',
  CONVOCATORIAS: 'CONVOCATORIAS',
  SALIR_APLICACION: 'SALIR_APLICACION',
  //desarrollo profesional
  CONDECORAR_ELEMENTO: 'CONDECORAR_ELEMENTO',
  REALIZAR_EVALUACION_DESEMPEÑO_ACADEMICO: 'REALIZAR_EVALUACION_DESEMPEÑO_ACADEMICO',
  REALIZAR_EVALUACION_ANUAL: 'REALIZAR_EVALUACION_ANUAL',
  REALIZAR_EVALUACION_DESEMPEÑO: 'REALIZAR_EVALUACION_DESEMPEÑO',
  SUGERIR_CURSO: 'SUGERIR_CURSO',
  ASIGNACION_CUP: 'ASIGNACION_CUP',
  //enlace c3/aspirantes
  REGISTRO_RESULTADOS_C3: 'REGISTRO_RESULTADOS_C3',
  VISUALIZACION_RESULTADOS_C3: 'VISUALIZACION_RESULTADOS_C3',
  //enlace c3/PERSONAL
  REGISTRO_RESULTADOS_C3: 'REGISTRO_RESULTADOS_C3',
  TURNAR_C3: 'TURNA_C3',
  //RECURSOS HUMANOS/PERSONAL
  REGISTRO_NUEVO_PERSONAL: 'REGISTRO_NUEVO_PERSONAL',
  REGISTRAR_TRAMITE_ADMINISTRATIVO: 'REGISTRAR_TRAMITE_ADMINISTRATIVO',
  CAMBIO_DE_ESTATUS: 'CAMBIO_DE_ESTATUS',
  ASIGNACION_PUESTO_FUNCION_ADSCRIPCION: 'ASIGNACION_PUESTO_FUNCION_ADSCRIPCION',
  //PERSONAL/PREASPIRANTE
  CAPTURA_FOTOGRAFIA: 'CAPTURA_FOTOGRAFIA',
  CAPTURA_VOZ: 'CAPTURA_VOZ',
  CAPTURA_HUELLAS: 'CAPTURA_HUELLAS',
  REGISTRO_RESULTADO_CONSULTA_PREVIA: 'REGISTRO_RESULTADO_CONSULTA_PREVIA',
  REGISTRO_CUIP: 'REGISTRO_CUIP',
  //PERSONAL/PERSONAL
  REGISTRO_MEDIAS_FILACIONES: 'REGISTRO_MEDIAS_FILACIONES',
  REIMPRESION_CREDENCIAL: 'REIMPRESION_CREDENCIAL',
  REGISTRO_CREDENCIAL: 'REGISTRO_CREDENCIAL',
  REGISTRO_CUIP: 'REGISTRO_CUIP',
}

export const FEATURES_PERFILES = {
  [FEATURES.CANDIDATOS]: [
    PERFILES['Administrador IPH+'],
    PERFILES.IFCSP_RECLUTAMIENTO,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.CONTROL_ASPIRANTES]: [
    PERFILES['Administrador IPH+'],
    PERFILES.IFCSP_RECLUTAMIENTO,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.CAPACITADORES]: [
    PERFILES['Administrador IPH+'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.AULAS]: [
    PERFILES['Administrador IPH+'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.CURSOS]: [
    PERFILES['Administrador IPH+'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.CURSOS_PROGRAMADOS]: [
    PERFILES['Administrador IPH+'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.SUGERENCIA_CURSOS]: [
    PERFILES['Administrador IPH+'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.FATIGA_ENTRADA_SALIDA_ARMA]: [
    PERFILES['Administrador IPH+'],
    PERFILES.Armeria,
    PERFILES['ARMERIA_PASE DE LISTA'],
  ],
  [FEATURES.REGISTRO_LOC]: [PERFILES['Administrador IPH+'], PERFILES.Armeria, PERFILES.ARMERIA_LOC],
  [FEATURES.INVENTARIO_ITEMS]: [
    PERFILES['Administrador IPH+'],
    PERFILES.Armeria,
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
  ],
  [FEATURES.ASIGNACION_ITEMS_PERSONAL]: [
    PERFILES['Administrador IPH+'],
    PERFILES.Armeria,
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
  ],
  [FEATURES.CONVOCATORIAS]: [
    PERFILES['Administrador IPH+'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CONVOCATORIAS_CONDECORACIONES,
  ],
  [FEATURES.SALIR_APLICACION]: PERFILES['Administrador IPH+'],
  //desarrollo profesional
  [FEATURES.CONDECORAR_ELEMENTO]: [
    PERFILES['Administrador IPH+'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CONVOCATORIAS_CONDECORACIONES,
  ],
  [FEATURES.REALIZAR_EVALUACION_DESEMPEÑO_ACADEMICO]: [
    PERFILES['Administrador IPH+'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_EVALUACIONES,
  ],
  [FEATURES.REALIZAR_EVALUACION_ANUAL]: [
    PERFILES['Administrador IPH+'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_EVALUACIONES,
  ],
  [FEATURES.REALIZAR_EVALUACION_DESEMPEÑO]: [
    PERFILES['Administrador IPH+'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_EVALUACIONES,
  ],
  [FEATURES.SUGERIR_CURSO]: [PERFILES['Administrador IPH+'], PERFILES.DP_ADMINISTRADOR, PERFILES.DP_EVALUACIONES],
  [FEATURES.ASIGNACION_CUP]: [PERFILES['Administrador IPH+'], PERFILES.DP_ADMINISTRADOR, PERFILES.DP_EVALUACIONES],
  //enlace c3/aspirantes
  [FEATURES.REGISTRO_RESULTADOS_C3]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE C3_ADMINISTRADOR'],
    PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'],
  ],
  //enlace c3/PERSONAL
  [FEATURES.REGISTRO_RESULTADOS_C3]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE C3_ADMINISTRADOR'],
    PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'],
  ],
  [FEATURES.TURNAR_C3]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE C3_ADMINISTRADOR'],
    PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'],
  ],
  [FEATURES.VISUALIZACION_RESULTADOS_C3]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE C3_ADMINISTRADOR'],
    PERFILES['ENLACE C3_CAPTURA DE RESULTADOS'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CUP,
    PERFILES.Armeria,
    PERFILES.ARMERIA_LOC,
    PERFILES['ARMERIA_PASE DE LISTA'],
    PERFILES['ARMERIA_PERSONAL LOC'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
  ],
  //RECURSOS HUMANOS/PERSONAL
  [FEATURES.REGISTRO_NUEVO_PERSONAL]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_REGISTRO DE PERSONAL'],
  ],
  [FEATURES.REGISTRAR_TRAMITE_ADMINISTRATIVO]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_TRAMITES ADMINISTRATIVOS'],
  ],
  [FEATURES.CAMBIO_DE_ESTATUS]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
  ],
  [FEATURES.ASIGNACION_PUESTO_FUNCION_ADSCRIPCION]: [
    PERFILES['Administrador IPH+'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
  ],
  //PERSONAL/PREASPIRANTE
  [FEATURES.CAPTURA_FOTOGRAFIA]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_BIOMETRIA,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.CAPTURA_VOZ]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_BIOMETRIA,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.CAPTURA_HUELLAS]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_BIOMETRIA,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REGISTRO_RESULTADO_CONSULTA_PREVIA]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REGISTRO_CUIP]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES['Personal / Site'],
  ],
  //PERSONAL/PERSONAL
  [FEATURES.REGISTRO_MEDIAS_FILACIONES]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REIMPRESION_CREDENCIAL]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_CREDENCIALIZACION,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REGISTRO_CREDENCIAL]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_CREDENCIALIZACION,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REGISTRO_CUIP]: [
    PERFILES['Administrador IPH+'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES['Personal / Site'],
  ],
}
